import styled from 'styled-components';

export default function DiscountAmountInput({ value, setValue, placeholder, width, disabled, isFlex = false }) {

  function onChangeInput(e) {
    setValue(e.target.value);
  }

  return (
    <InputView width={width} disabled={disabled} isFlex={isFlex}>
      <Input
        type='text'
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        onChange={onChangeInput} />
    </InputView>
  );
}

const InputView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  padding: 0 8px;

  width: ${props => props.width ? `${props.width}px` : props.isFlex ? undefined : '100%'};
  flex: ${props => props.isFlex ? 1 : undefined};
  height: 30px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
  background-color: ${props => props.disabled ? props.theme.buttonFill : props.theme.subBackground};

  &:focus-within {
    border-color: ${props => props.theme.subKey};
  }

  transition: border-color 0.3s ease-in-out;
`;

const Input = styled.input`
  width: 100%;
  height: 21px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  text-align: right;

  color: ${props => props.theme.subKey};
  background: transparent;

  border: none;
  outline: none;
  padding: 0;

  &::placeholder {
    color: ${props => props.theme.subText};
  }
`;
